import { Component, OnInit } from '@angular/core';
import { AccountRecoveryUtil } from './shared/utils/accountrecovery.utils';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AppTranslationService } from './app-translation.service';
import { filter, map } from 'rxjs/operators';
import { VueAppDefaultsService } from '@vue/vueframework';
import { SessionDataService } from './shared/services/session-data.service';

@Component({
  selector: 'app-root',
  standalone: false,
  styleUrls: [ './app.component.css' ],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  public direction: string;
  public skipLinkPath: string;

  public constructor(
    private accountRecoveryUtil: AccountRecoveryUtil,
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private appTranslationService: AppTranslationService,
    private vueDefaultsService: VueAppDefaultsService,
    private sessionDataService: SessionDataService
  ) {}

  public ngOnInit(): void {
    this.updateDirection(this.accountRecoveryUtil.getLocaleFromUrl());
    const untranslatedPrefix = '[@@';
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          if (!this.router.url.endsWith('#main-content')) {
            this.skipLinkPath = `${this.router.url}#main-content`;
          }
          let title = this.vueDefaultsService.getDefaultPageTitle();
          const {
            pageTitle
          } = this.activatedRoute.firstChild.firstChild.snapshot.data;

          if (pageTitle && pageTitle.key) {
            const bundle = pageTitle.i18nBundle ?
              pageTitle.i18nBundle :
              this.vueDefaultsService.getPortalMessageBundle();
            title = this.appTranslationService.getTranslation(
              bundle,
              pageTitle.key
            );

            if (title.startsWith(untranslatedPrefix)) {
              title = this.vueDefaultsService.getDefaultPageTitle();
            }
          }

          return title;
        })
      )
      .subscribe((title: string) => {
        this.titleService.setTitle(title);
        this.updateDirection(this.sessionDataService.getLocale());
      });
  }

  /**
   * Returns the candidate to the WebNG login page.
   */
  public returnToLogin(): void {
    this.accountRecoveryUtil.navigateToLogin();
  }

  /**
   * Changes the direction based on locale. Arabic locale will be rtl, all else will be ltr
   * First called using locale from URL, subsequent calls will use locale from session storage.
   * @param locale The locale used to for direction and translations
   */
  public updateDirection(locale: string): void {
    // if planning on using more rtl languages, maybe extract to service?
    if (locale && (locale.toLowerCase() === 'ar_ae' || locale.toLowerCase() === 'ar-ae')) {
      this.direction = 'rtl';
    } else {
      this.direction = 'ltr';
    }
  }
}
